import privateApi from '@/lib/client/private-instance';
import { QueryFunctionContext } from '@tanstack/react-query';
import {
  IAsset,
  IBuilder,
  ICollectionTemplate,
  INavigationMenu,
  INavigationMenuDetail,
  IPage,
} from '@/types/site';
import { HttpTypes } from '@/types';
import { BaseCustomPage } from '@/types/http/custom-pages/common';
import axios from 'axios';
import { env } from '@/lib/env';

export const getAllMenu = async (): Promise<HttpTypes.IResponse<INavigationMenu[]>> => {
  const res = await privateApi.get('/sites/menu/list');
  return res.data;
};

export const getMenuById = async ({
  queryKey,
}: QueryFunctionContext): Promise<HttpTypes.IResponse<INavigationMenuDetail>> => {
  const [, params] = queryKey;

  const res = await privateApi.get(`/sites/menu/detail/${(params as { id: string }).id}`);
  return res.data;
};

export const getAllPage = async (): Promise<HttpTypes.IResponse<IPage[]>> => {
  const res = await privateApi.get('/sites/pages/list');
  return res.data;
};

export const saveBuilder = async (data: unknown): Promise<HttpTypes.IResponse<IBuilder>> => {
  const res = await privateApi.post('/sites/builder/modify', data);
  return res.data;
};

export const getBuilder = async ({
  queryKey,
}: QueryFunctionContext): Promise<HttpTypes.IResponse<IBuilder>> => {
  const [, params] = queryKey;
  const res = await privateApi.get(`/sites/builder/page`, {
    params,
  });
  return res.data;
};

export const listAssets = async ({
  queryKey,
}: QueryFunctionContext): Promise<HttpTypes.IResponse<IAsset[]>> => {
  const [, params] = queryKey;
  const res = await privateApi.get('/sites/files/manager/list', { params });
  return res.data;
};

export const searchProducts = async ({
  queryKey,
}: QueryFunctionContext): Promise<{
  products: { image_url: string; name: string; price: number; vendor: string }[];
  suggesstions: string[];
}> => {
  const [, _] = queryKey;
  return new Promise((res) => {
    setTimeout(() => {
      const mockSuggestions = [
        'bagus berkualitas',
        'aman dan terpercaya',
        'sehat senantiasa selamanya',
        'terbaik',
      ];
      const mockProducts = [
        {
          image_url: 'https://picsum.photos/id/1/200/300',
          name: 'High-End Gaming Laptop with Extended Battery',
          price: 22999999,
          vendor: 'Tech World',
        },
        {
          image_url: 'https://picsum.photos/id/1/200/300',
          name: 'Noise Cancelling Headphones with Adaptive Sound',
          price: 4399999,
          vendor: 'SoundPlus',
        },
        {
          image_url: 'https://picsum.photos/id/1/200/300',
          name: 'Smartphone Pro Max with Ultra Wide Camera',
          price: 15999999,
          vendor: 'Mobile Hub',
        },
        {
          image_url: 'https://picsum.photos/id/1/200/300',
          name: 'Smartwatch Series 5 with Fitness Tracking',
          price: 5999999,
          vendor: 'Wearable Tech',
        },
        {
          image_url: 'https://picsum.photos/id/1/200/300',
          name: 'Ultra-Wide 4K Monitor with HDR and Eye Care',
          price: 7899999,
          vendor: 'Display Master',
        },
      ];

      res({
        products: mockProducts,
        suggesstions: mockSuggestions,
      });
    }, 2000);
  });
};

export const getCollectionTemplate = async (): Promise<
  HttpTypes.IResponse<ICollectionTemplate[]>
> => {
  const res = await privateApi.get(`/sites/builder/collections/templates`, {
    params: {
      page: 1,
      pageSize: 100,
    },
  });
  return res.data;
};

export const getAllPages = async (): Promise<HttpTypes.IResponse<BaseCustomPage[]>> => {
  const res = await privateApi.get('/sites/pages/list');
  return res.data;
};

export const getFonts = async (): Promise<{ items: unknown[] }> => {
  const res = await axios.get(
    `https://www.googleapis.com/webfonts/v1/webfonts?key=${env.NEXT_PUBLIC_GOOGLE_API_KEY}`
  );
  return res.data;
};

export const siteService = {
  getAllMenu,
  getMenuById,
  getAllPage,
  saveBuilder,
  getBuilder,
  getCollectionTemplate,
  getAllPages,
};
